import axios from '../javascript/custom-axios';
const RESOURCE_NAME = 'customization';

export default {
  add(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },
  update(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },
  get() {
    return axios.get(`${RESOURCE_NAME}/get`);
  },
};
